import axios from 'axios';
import { API_BASE_URL, CONVERSATIONAL_API_BASE_URL } from '../config/constants';


// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Create API instance for file uploads (no default Content-Type header)
const uploadApi = axios.create({
  baseURL: API_BASE_URL
});

// Create public API instance for pre-screening tests (no auth required)
const publicApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Create conversational API instance (always localhost for development)
const conversationalApi = axios.create({
  baseURL: CONVERSATIONAL_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add auth token to upload requests
uploadApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Add response interceptor for public API (no auth redirect)
publicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Public API Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for conversational API (no auth redirect)
conversationalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Conversational API Error:', error);
    return Promise.reject(error);
  }
);

api.getHiringPipeline = async (userId) => {
  try {
      console.log('API Service: Fetching hiring pipeline for userId:', userId);
      
      if (!userId) {
          throw new Error('User ID is required');
      }

      const response = await api.get(`/admin/users/${userId}/hiring-pipeline`);
      console.log('API Service: Received response:', response.data);

      if (!response.data) {
          throw new Error('No data received from server');
      }

      return {
          success: true,
          jobs: Array.isArray(response.data.jobs) ? response.data.jobs : [],
          count: response.data.count || 0
      };
  } catch (error) {
      console.error('API Service Error:', error);
      throw error;
  }
};

api.allocateTokens = async (userId, amount, expiryDate, reason) => {
  const response = await api.post('/admin/users/tokens/allocate', {
      userId,
      amount,
      expiryDate,
      reason
  });
  return response.data;
};

export const getUserActivity = async (userId) => {
  try {
    const response = await api.get(`/admin/users/${userId}/activity`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};


export { publicApi, conversationalApi, uploadApi };
export default api; 